import "bootstrap/dist/js/bootstrap.bundle.min"
global.moment = require("moment")
import "moment-timezone"

import "blueimp-file-upload/js/jquery.iframe-transport.js"
import "blueimp-file-upload/js/jquery.fileupload.js"
import "./lib/jquery.fileupload-dragover.js"
import "./lib/dataTables.moment"

import "select2"
import { applySelect2Defaults } from "./lib/select2-language"
import { syncNativeDateLocale } from "./lib/native-date-locale"

applySelect2Defaults()
syncNativeDateLocale(document)

if (window.i18next && typeof i18next.on === 'function') {
    i18next.on('languageChanged', function () {
        applySelect2Defaults();
        syncNativeDateLocale(document);
        if (window.moment && typeof window.moment.locale === 'function') {
            window.moment.locale(i18next.language || 'en');
        }
    });
}

console.log("JS: Footer libraries loaded.")
